import React from 'react'
import sogeva from '../../Assets/sogeva.jpeg'
import busch from '../../Assets/busch.jpg'
import vericom from '../../Assets/vericom.png'
import pd from '../../Assets/pd.jpg'
import president from '../../Assets/president.jpeg'
import refine from '../../Assets/refine.png'
import prestige from '../../Assets/prestige.jpg'
import '../../css/Main/Companies.css'
import { useNavigate } from 'react-router-dom';

const CompanySlider = () => {

  const navigate = useNavigate();
    
  return (
    <div className="companies">
        <h2>Gyártók</h2>
        <div className="companies-images">
            <img src={sogeva} alt="sogeva" onClick={() => navigate('/gyartok/Sogeva')}/>
            <img src={busch} alt="busch" onClick={() => navigate('/gyartok/Busch')}/>
            <img src={refine} alt="refine" onClick={() => navigate('/gyartok/Refine')}/>
            <img src={prestige} alt="prestige" onClick={() => navigate('/gyartok/Prestige')}/>
        </div>
    </div>
  )
}

export default CompanySlider